<template>
  <div
    class="DecodeTokenPageView view"
    v-loading.fullscreen.lock="$store.getters['authServicesPoints/isWaitingForAuthServicePointData']"
    element-loading-text="Pobieranie danych"
    element-loading-background="rgba(45, 47, 66, 1)"
  >
    <LayoutWrapper
      :brandTheme="$store.getters['global/brandTheme']"
      :brandLogo="$store.getters['global/brandLogo']"
      :logoAboveForm="$store.getters['global/logoAboveForm']"
      :supportEmail="$store.getters['global/supportEmail']"
      v-if="!$store.getters['authServicesPoints/isWaitingForAuthServicePointData']"
    >
      <router-view slot="views"></router-view>
    </LayoutWrapper>
  </div>
</template>

<script>
import store from "@/store";
import ManageTokenService from "@/services/ManageTokenService";
import LayoutWrapper from "@/components/Common/LayoutWrapper";

export default {
  name: "DecodeTokenPage",
  store,
  components: { LayoutWrapper },
  props: {
    token: {
      type: String,
      default: "",
    },
  },
  async mounted() {
    const token = this.token || ManageTokenService.getTokenFromStorage();

    window.addEventListener("pageshow", (event) => {
      if (event.persisted && !token) {
        // strona załadowana z pamieci podrecznej przegladarki
        redirectWhenTokenIsNotPresent();
      }
    });

    if (token) {
      await this.$store.dispatch("authServicesPoints/getAuthServicePointSettingsByToken", token);
    } else {
      this.redirectWhenTokenIsNotPresent();
      return;
    }

    if (this.$store.getters["authServicesPoints/tokenIsValid"]) {
      ManageTokenService.addTokenToStorage(token);
      this.$router.push({ path: "/auth" });
    } else {
      ManageTokenService.removeTokenFromStorage();
      this.$router.push({ path: "/error" });
    }
  },

  methods: {
    redirectWhenTokenIsNotPresent() {
      if (document.URL.includes("whitephone")) {
        if (document.URL.includes("staging")) {
          window.location.replace("https://staging-system.whitephone.pl");
        } else {
          window.location.replace("https://system.whitephone.pl");
        }
      } else {
        this.$store.dispatch("authServicesPoints/setStateForWaitingForAuthServicePointData", false);
        this.$router.push({ path: "/info" });
      }
    },
  },
};
</script>
<style lang="sass">
.DecodeTokenPageView
  display: flex
  min-height: 0
  flex: 1 1 auto
  flex-direction: column
</style>



// WEBPACK FOOTER //
// src/views/DecodeTokenPage.vue